import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldX, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BlockedAccess = ({ requiredPermission, pageName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <ShieldX className="w-8 h-8 text-red-600" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {t('access.blocked.title', 'Accès Refusé')}
        </h1>

        {/* Message */}
        <p className="text-gray-600 mb-6">
          {t('access.blocked.message', 'Vous n\'avez pas les permissions nécessaires pour accéder à cette page.')}
        </p>

        {/* Page Info */}
        {pageName && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-500 mb-1">
              {t('access.blocked.page', 'Page demandée:')}
            </p>
            <p className="font-medium text-gray-900">
              {pageName}
            </p>
          </div>
        )}

        {/* Permission Info */}
        {requiredPermission && (
          <div className="bg-red-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-red-600 mb-1">
              {t('access.blocked.permission', 'Permission requise:')}
            </p>
            <p className="font-medium text-red-800">
              {requiredPermission}
            </p>
          </div>
        )}

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={handleGoBack}
            className="w-full flex items-center justify-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('access.blocked.goBack', 'Retour')}
          </button>
          
          <button
            onClick={handleGoHome}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            {t('access.blocked.goHome', 'Retour à l\'accueil')}
          </button>
        </div>

        {/* Help Text */}
        <p className="text-xs text-gray-500 mt-6">
          {t('access.blocked.help', 'Contactez votre administrateur si vous pensez que c\'est une erreur.')}
        </p>
      </div>
    </div>
  );
};

export default BlockedAccess;









